module.exports = __webpack_public_path__ + "img/cooperate_qy_11@2x.a0c28b83.png";